// Resolves a top-level slug URL to a Service or Feature page.
import React from "react";
import { useParams } from "react-router-dom";
import ServicePage from "@/components/site/ServicePage";
import FeaturePage from "@/components/site/FeaturePage";
import NotFoundPage from "@/pages/NotFoundPage";
import { findCatalogEntry } from "@/constants/cosecCatalog";

export default function CatalogRouter() {
  const { slug } = useParams();
  const entry = findCatalogEntry(slug);
  if (!entry) return <NotFoundPage />;
  if (entry.kind === "feature") return <FeaturePage entry={entry} />;
  return <ServicePage entry={entry} />;
}
